const slugToTitle = (category) => {
    switch (category) {
        case 'client-stories':
            return 'Client Stories';
        case 'replays':
            return 'Event Replays';
        case 'sponsored-content':
            return 'Sponsored Content';
        case 'sponsored-replays':
            return 'Sponsored Replays';
        default:
            return category[0].toUpperCase() + category.slice(1);
    }
};

const titleToSlug = (category) => {
    switch (category) {
        case 'Client Stories':
            return 'client-stories';
        case 'Event Replays':
            return 'replays';
        case 'Sponsored Content':
            return 'sponsored-content';
        case 'Sponsored Replays':
            return 'sponsored-replays';
        default:
            return category.toLowerCase();
    }
};

/*
 * This method takes an Algolia search state object and uses the QS library
 * to parse it into a URI string. Make adjustments to the search state object
 * prior to calling qs.stringify() to remove or reformat how the URI string
 * will finally look.
 */
const searchStateToUrl = (searchState) => {
    if (!searchState) {
        return {};
    }

    // Clone the state object so we can modify it without Algolia reacting.
    const urlState = { ...searchState };

    // Remove configure object parameter, we don't want users controlling this by
    // adjusting their input URI
    delete urlState.configure;
    delete urlState.page;

    if (urlState.query) {
        urlState.keywords = urlState.query;
    }
    delete urlState.query;

    // We will be rewriting refinements as individual parameters rather than as
    // a nested parameter under the refinementList array key.
    delete urlState.refinementList;

    // Add each refinement list as its own base key to the URI string.
    for (const list in searchState.refinementList) {
        if (searchState.refinementList[list]) {
            switch (list) {
                case 'topics':
                    urlState.topic = searchState.refinementList[list].join(',');
                    break;
                case 'categories.title':
                    const categories = [];
                    for (const i in searchState.refinementList[list]) {
                        categories.push(titleToSlug(searchState.refinementList[list][i]));
                    }
                    urlState.categories = categories.join(',');
                    break;
                default:
                    urlState[list] = searchState.refinementList[list];
            }
        }
    }

    return urlState;
};

/*
 * This method takes a URI string and parses it into an object. If any changes to
 * the Algolia search state object were made in the createURL() method they will need
 * to be reverse engineered here to ensure a properly formatted and structured search
 * state object is returned.
 */
const urlToSearchState = (urlState) => {
    if (urlState.keywords) {
        urlState.query = urlState.keywords;
        delete urlState.keywords;
    }

    // Algolia looks for a refinementList key in the search state object, so we
    // need to re-nest our refinementList values there. We also want to ensure we
    // delete the now unnecessary object properties.
    if (urlState.eventType) {
        if (!urlState.refinementList) {
            urlState.refinementList = [];
        }
        urlState.refinementList.eventType = urlState.eventType.split(', ');
        delete urlState.eventType;
    }

    if (urlState.topic) {
        if (!urlState.refinementList) {
            urlState.refinementList = [];
        }
        urlState.refinementList.topics = urlState.topic.split(',');
        delete urlState.topic;
    }

    if (urlState.categories) {
        if (!urlState.refinementList) {
            urlState.refinementList = [];
        }

        const categories = urlState.categories.split(',').map(slugToTitle);
        urlState.refinementList['categories.title'] = categories;
        delete urlState.categories;
    }

    return urlState;
};

export { searchStateToUrl, urlToSearchState };
